import React, { Fragment, useEffect, useState, useRef } from "react";
import ActionBar from "../../common/ActionBar/index";
import theme from "../../../assets/theme";
import HostService from "../../../services/HostService";
import styled from "styled-components";
import CustomTable from "../../common/CustomTable/MaterialCustomTable";
import labels from "../../../helpers/labels.json";
import { navigate, useLocation } from "@reach/router";
import COLORS from "../../../assets/Colors";
import _ from "lodash";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../helpers/functions";
import useUser from "../../../hooks/useUser";

const ViewHost = () => {
  const [state, setState] = useState();
  const MTRef = useRef();
  const [selectedFilter, setSelectedFilter] = useState();
  const location = useLocation();
  const orgId = location?.state?.orgId;
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const { userObject } = useUser();

  const handleClick = (rowData) => {
    if (userObject?.createModifyHost === 1) {
      navigate(
        `/dashboard/eventmanager/event-hosts/view-hosts/${rowData?.hostId}`,
      );
    } else {
      enqueueSnackbar("Updation of host is not permitted", {
        variant: "warning",
      });
    }
  };

  const columns = [
    {
      field: "firstName",
      title: labels.hsot_name,
      sorting: true,
      render: (rowData) => (
        <Center style={{ color: rowData?.hostStatus === 0 && "#d91b1b" }}>
          {rowData.firstName + " " + rowData?.lastName}
        </Center>
      ),
      width: 180,
    },
    {
      field: "mailId",
      title: labels.email_id,
      sorting: false,
      render: (rowData) => (
        <Center style={{ color: rowData?.hostStatus === 0 && "#d91b1b" }}>
          {rowData.mailId}
        </Center>
      ),
      width: 250,
    },
    {
      field: "contactNumber",
      title: labels.contact_number,
      sorting: true,
      render: (rowData) => (
        <Center style={{ color: rowData?.hostStatus === 0 && "#d91b1b" }}>
          {rowData.contactNumber}
        </Center>
      ),
    },
    {
      field: "status",
      title: labels["host-status"],
      sorting: false,
      render: (rowData) => (
        <Center style={{ color: rowData?.hostStatus === 0 && "#d91b1b" }}>
          {rowData?.hostStatus === 1 ? "Active" : "Deactive"}
        </Center>
      ),
    },
    {
      field: "events",
      title: labels["host-events"],
      sorting: false,
      render: (rowData) =>
        rowData.hostStatus === 0 ? (
          <ActionButton>
            <img
              src={require("../../../assets/images/Asset 3.svg")}
              alt="submit"
            />
          </ActionButton>
        ) : (
          <ActionButton
            onClick={() =>
              navigate(`/dashboard/eventmanager/event-hosts/view-events`, {
                state: {
                  orgId: orgId,
                  hostId: rowData?.hostId,
                },
              })
            }
          >
            <img
              src={require("../../../assets/images/Asset 4.svg")}
              alt="submit"
            />
          </ActionButton>
        ),
    },
    {
      field: "orgStatus",
      title: labels.action,
      sorting: false,
      render: (rowData) => (
        <ActionButton
          onClick={() => {
            handleClick(rowData);
          }}
        >
          <img
            src={require("../../../assets/images/Icons for Digital Events_V1-02.svg")}
            alt="submit"
          />
        </ActionButton>
      ),
    },
  ];

  useEffect(() => {
    async function getAllHost() {
      try {
        const response = await HostService.getAllHost(orgId);
        setState({ data: response.hosts });
      } catch (error) {
        setState({ state: [] });
        const message = getErrorMessage(error);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoading(false);
      }
    }
    getAllHost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case "view_organisation":
        navigate(`/dashboard/eventmanager/event-hosts/view-event-host`);
        break;
      default:
        break;
    }
  };

  return (
    <Fragment>
      <ActionBar
        breadcrumbs={["View Organisation", "View Hosts"]}
        {...{ onBreadcrumbClick }}
      />
      {/* <Heading>View Hosts</Heading> */}
      <Padding>
        <CustomTable
          hidePagination={state?.lastPage === 1}
          pageSize={state?.length ? state?.length : 10}
          pluralTitle={"Host"}
          singularTitle={"Host"}
          placeholderText={"Search"}
          noToolbar={true}
          {...{
            columns,
            selectedFilter,
            setSelectedFilter,
            MTRef,
          }}
          loading={loading}
          data={state?.data}
          hideFilterBar
          state={state}
        />
      </Padding>
    </Fragment>
  );
};

export default ViewHost;

const Padding = styled.div`
  // padding: 30.3px 15px 15.7px 15px;
  @media ${theme?.breakpoints?.sm_up} {
    padding-top: 10px;
    padding-bottom: 50px;
    padding-left: 35px;
    padding-right: 53px;
  }
`;

export const HeadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 12px;
`;

export const ActionButton = styled.button`
  border: none;
  background: none;
  outline: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 12px;
`;

const Center = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: #8294a5;
  font-weight: 600;
`;

export const HyperLink = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 14px;
  color: ${COLORS.LIGHT_BLUE_LABEL};
  text-decoration: underline;
  margin-right: ${({ marginRight }) => (marginRight ? marginRight : "0px")};
  opacity: ${({ disabled }) => (disabled ? "0.5" : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

export const Heading = styled.span`
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: ${theme.fonts.primaryFontExtraBold};
  font-size: 18px;
  color: ${COLORS.LIGHT_BLUE_LABEL};
`;
